import React, { useState } from 'react';
import { formatByDecimalPlaces, formatMetric, formatNumberWithCN } from '../utils';
import { AggregateInfoType, ColumnType } from '../common/type';
import PeriodCompareItem from '../MetricCard/PeriodCompareItem';
import { SwapIcon } from '../components/CustomIcons';
import styles from './index.module.scss';

type Props = {
  aggregateInfo: AggregateInfoType;
  currentMetricField: ColumnType;
};

const MetricInfo: React.FC<Props> = ({ aggregateInfo, currentMetricField }) => {
  const { metricInfos } = aggregateInfo || {};
  const metricInfo = metricInfos?.[0];
  const { date, value, statistics } = metricInfo || { date: '', value: '', statistics: {} };
  const { dataFormatType, dataFormat } = currentMetricField;

  const [isNumber, setIsNumber] = useState(false);
  const handleNumberClick = () => {
    setIsNumber(!isNumber);
  };

  return (
    <div className={styles.metricInfo}>
      <div className={styles.metricInfoIndicator}>
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <div className={styles.metricInfoIndicatorValue}>
            {dataFormatType === 'percent' || dataFormatType === 'decimal'
              ? `${formatByDecimalPlaces(
                  dataFormat?.needMultiply100 ? +value * 100 : value,
                  dataFormat?.decimalPlaces || 2
                )}${dataFormatType === 'percent' ? '%' : ''}`
              : isNumber
              ? formatMetric(value)
              : formatNumberWithCN(+value)}
          </div>
          {!isNaN(+value) && +value >= 10000 && (
            <div className={styles.metricInfoIndicatorSwitch}>
              <SwapIcon onClick={handleNumberClick} />
            </div>
          )}
        </div>
        <div className={styles.metricInfoBottomSection}>
          <div className={styles.metricInfoDate}>
            最新数据日期：<span className={styles.metricInfoDateValue}>{date}</span>
          </div>
          {metricInfos?.length > 0 && (
            <div className={styles.metricInfoPeriodCompare}>
              {Object.keys(statistics).map((key: any) => (
                <PeriodCompareItem key={key} title={key} value={metricInfos[0].statistics[key]} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricInfo;
